import React from "react";
import ProfileImg from "./../../../assets/images/profileImage.jpg";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
let EventAttendance = () => {
  let TableData = [
    {
      date: "JAN 4, 2022",
      eventTitle: "Phasellus sagittis eleifend...",
      tutorName: "Willow Anderson",
      noOfStudent: 100,
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      venue: "Online",
      status: "Complated",
    },
    {
      date: "JAN 4, 2022",
      eventTitle: "Phasellus sagittis eleifend...",
      tutorName: "Willow Anderson",
      noOfStudent: 70,
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com",
      phone: "1234567890",
      venue: "3501 California St",
      status: "Complated",
    },
    {
      date: "JAN 4, 2022",
      eventTitle: "Phasellus sagittis eleifend...",
      tutorName: "Willow Anderson",
      noOfStudent: 70,
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com",
      phone: "1234567890",
      venue: "Online",
      status: "Cancelled",
    },
    {
      date: "JAN 4, 2022",
      eventTitle: "Phasellus sagittis eleifend...",
      tutorName: "Willow Anderson",
      noOfStudent: 100,
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      venue: "Online",
      status: "Complated",
    },
    {
      date: "JAN 4, 2022",
      eventTitle: "Phasellus sagittis eleifend...",
      tutorName: "Willow Anderson",
      noOfStudent: 70,
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com",
      phone: "1234567890",
      venue: "3501 California St",
      status: "Complated",
    },
    {
      date: "JAN 4, 2022",
      eventTitle: "Phasellus sagittis eleifend...",
      tutorName: "Willow Anderson",
      noOfStudent: 70,
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com",
      phone: "1234567890",
      venue: "Online",
      status: "Cancelled",
    },
  ];
  return (
    <div>
      <div className="table-container">
        <div className="table-header">
          <p className="table-heading">Event Attendance</p>
        </div>
        <div className="table-data-container">
          <table>
            <thead>
            <tr>
              <th className="event-attendance-table-id-heading">ID</th>
              <th className="event-attendance-table-date-heading">Date</th>
              <th className="event-attendance-table-event-title-heading">
                Event Title
              </th>
              <th className="event-attendance-table-tutor-name-heading">
                Tutor Name
              </th>
              <th className="event-attendance-table-no-of-student-heading">
                No. OF Student
              </th>
              <th className="event-attendance-table-country-heading">
                country
              </th>
              <th className="event-attendance-table-state-heading">State</th>
              <th className="event-attendance-table-city-heading">City</th>
              <th className="event-attendance-table-email-heading">Email</th>
              <th className="event-attendance-table-phone-heading">Phone</th>
              <th className="event-attendance-table-venue-heading">Venue</th>
              <th className="event-attendance-table-status-heading">Status</th>
              <th className="event-attendance-table-action-heading"></th>
            </tr>
            </thead>
            {TableData.map((tableValue, tableIndex) => {
              return (
                <tr key={tableIndex}>
                  <td className="table-id-data">{tableIndex + 1}</td>
                  <td className="table-data">{tableValue.date}</td>
                  <td className="table-data">{tableValue.eventTitle}</td>
                  <td className="table-data">{tableValue.tutorName}</td>
                  <td className="table-center-data">
                    {tableValue.noOfStudent}
                  </td>
                  <td className="table-data">{tableValue.country}</td>
                  <td className="table-data">{tableValue.state}</td>
                  <td className="table-data">{tableValue.city}</td>
                  <td className="table-email-data">{tableValue.email}</td>
                  <td className="table-data">{tableValue.phone}</td>
                  <td className="table-data">{tableValue.venue}</td>
                  <td className="table-data">
                    <div
                      className="event-attendance-table-status-card"
                      style={{
                        backgroundColor:
                          tableValue.status === "Cancelled"
                            ? "#FFB0B0"
                            : "#D2FFEB",
                        color:
                          tableValue.status === "Cancelled"
                            ? "#B80000"
                            : "#098B51",
                      }}
                    >
                      {tableValue.status}
                    </div>
                  </td>
                  <td className="table-data">
                    <select className="table-action-dropdown">
                      <option value="">Action</option>
                      <option value="View">View</option>
                    </select>
                  </td>
                </tr>
              );
            })}
          </table>
        </div>
        <div className="table-pagination-main">
          <Stack spacing={2}>
            <Pagination count={10} variant="outlined" shape="rounded" />
          </Stack>
        </div>
      </div>
    </div>
  );
};
export default EventAttendance;
